import Loader12 from "../ui/loader-12";

export type LoadingVariant = "full" | "inline" | "panel";

interface LoadingProps {
  message?: string;
  /** Дополнительный этап (например «Поднимаем окружение...» / «Выполняем запрос...») */
  stage?: string;
  /** full — страница / песочница; inline — строка в чате; panel — выполнение запроса в блоке кода */
  variant?: LoadingVariant;
  /** Подпись под заголовком (только variant full). null — не показывать */
  subtitle?: string | null;
}

/** Лоадер запроса: фирменная анимация + этап выполнения. */
export const Loading = ({
  message = "Загрузка...",
  stage,
  variant = "full",
  subtitle,
}: LoadingProps) => {
  const displayMessage = stage ?? message;
  const defaultSubtitle = "Нужно немного времени, чтобы подготовить инфраструктуру";
  const hintText = subtitle === undefined ? defaultSubtitle : subtitle;

  if (variant === "inline") {
    return (
      <div className="flex items-center gap-2 py-0.5 min-w-0" role="status" aria-live="polite">
        <div className="shrink-0 w-[28px] h-[34px] flex items-center justify-center overflow-hidden" aria-hidden>
          <div className="origin-center scale-[0.35]">
            <Loader12 />
          </div>
        </div>
        <span className="text-xs text-neutral-text/70 truncate">{displayMessage}</span>
      </div>
    );
  }

  if (variant === "panel") {
    return (
      <div
        className="p-3 sm:p-4 flex items-center justify-center min-h-[min(200px,36vh)] sm:min-h-[min(240px,40vh)] px-2 sm:px-4"
        role="status"
        aria-live="polite"
      >
        <div className="text-center w-full max-w-[min(100%,22rem)] mx-auto">
          <div className="flex justify-center mb-1 sm:mb-1.5" aria-hidden>
            <div className="origin-center scale-[0.58] sm:scale-[0.74] md:scale-[0.84] lg:scale-[0.94]">
              <Loader12 />
            </div>
          </div>
          <p className="text-neutral-text text-[clamp(0.8rem,2.8vw,1rem)] sm:text-base font-semibold font-body leading-tight px-1">
            {displayMessage}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[min(420px,52vh)] sm:min-h-[min(420px,46vh)] px-3 sm:px-4" role="status" aria-live="polite">
      <div className="text-center max-w-sm w-full">
        <div className="flex justify-center mb-2 sm:mb-3" aria-hidden>
          <div className="origin-center scale-95 sm:scale-105 md:scale-110 lg:scale-[1.12]">
            <Loader12 />
          </div>
        </div>
        <p className="text-neutral-text text-[clamp(1rem,3.5vw,1.125rem)] sm:text-lg font-semibold font-body leading-snug">
          {displayMessage}
        </p>
        {hintText != null && hintText !== "" && (
          <p className="mt-2 text-sm text-neutral-text/55 font-body">{hintText}</p>
        )}
      </div>
    </div>
  );
};

